import { render, staticRenderFns } from "./errorMessage.vue?vue&type=template&id=3b80c2f8&scoped=true"
import script from "./errorMessage.vue?vue&type=script&lang=js"
export * from "./errorMessage.vue?vue&type=script&lang=js"
import style0 from "./errorMessage.vue?vue&type=style&index=0&id=3b80c2f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b80c2f8",
  null
  
)

export default component.exports